<template lang="pug">
.container
    mainHeader
    mobileHeader
    heroHeader
    frontBlog
    .main
        mainContents
    footerBlock
</template>

<script>
import mobileHeader from '@/components/mobile-header';
import heroHeader from '@/components/hero-header.vue';
import mainContents from '@/components/main-contents';
import footerBlock from '@/components/footer-block';
import mainHeader from '@/components/header-menu';
import frontBlog from '@/components/front-blog';

export default {
  name: 'top',
  components: {
    mainHeader,
    mobileHeader,
    heroHeader,
    mainContents,
    footerBlock,
    frontBlog,
  },
  mounted() {
    window.scroll(0, 0);
  },
};
</script>

<style lang="scss">
@import '../assets/scss/_common';
.container {
  background: url('../assets/img/background.jpg');
  background-size: 100% auto;
  background-repeat: repeat-y;
  > .main {
    // padding: 60px;
  }
}
</style>
